import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking");
  const sessionId = new URLSearchParams(window.location.search).get("session_id");

  useEffect(() => {
    if (!sessionId) {
      setStatus("error");
      return;
    }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
        if (["failed", "expired"].includes(r.data.payment_status)) {
          setStatus("error");
          return;
        }
      } catch (e) {}
      if (attempts >= 8) {
        setStatus("pending");
        return;
      }
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen flex flex-col bg-[#F8FAF9]">
      <div className="p-6"><Logo /></div>
      <div className="flex-1 flex items-center justify-center px-6 pb-20">
        <div className="w-full max-w-md bg-white border border-[#E2EBF0] rounded-2xl shadow-sm p-8 text-center animate-fade-up" data-testid="payment-success-card">
          {status === "checking" && (
            <>
              <Loader2 className="h-10 w-10 text-[#10B981] mx-auto animate-spin" />
              <h1 className="font-heading font-bold text-xl text-[#0D3B2D] mt-5">Confirming your payment…</h1>
              <p className="text-sm text-[#4A635A] mt-2">This only takes a moment.</p>
            </>
          )}
          {status === "paid" && (
            <>
              <CheckCircle2 className="h-12 w-12 text-[#10B981] mx-auto" />
              <h1 className="font-heading font-bold text-2xl text-[#0D3B2D] mt-5" data-testid="payment-paid-title">Payment confirmed</h1>
              <p className="text-sm text-[#4A635A] mt-2">Thank you. We've emailed you a secure link to set your password and activate your client portal. Please check your inbox.</p>
            </>
          )}
          {status === "pending" && (
            <>
              <Loader2 className="h-10 w-10 text-[#F59E0B] mx-auto" />
              <h1 className="font-heading font-bold text-xl text-[#0D3B2D] mt-5">Payment processing</h1>
              <p className="text-sm text-[#4A635A] mt-2">Your payment is being finalized. You'll see it in your portal shortly.</p>
            </>
          )}
          {status === "error" && (
            <>
              <XCircle className="h-12 w-12 text-red-500 mx-auto" />
              <h1 className="font-heading font-bold text-xl text-[#0D3B2D] mt-5">Something went wrong</h1>
              <p className="text-sm text-[#4A635A] mt-2">We couldn't confirm this payment.</p>
            </>
          )}
          <Button onClick={() => navigate("/login")} data-testid="payment-success-portal-btn"
            className="mt-6 w-full bg-[#0D3B2D] hover:bg-[#071A13] text-white rounded-lg py-6">
            Go to Sign In
          </Button>
        </div>
      </div>
    </div>
  );
}
